/* src/app/components/company/company-add-edit/company-document-upload.component.css */
:host ::ng-deep .cloud-upload .p-fileupload-buttonbar {
  display: none;
}
:host ::ng-deep .cloud-upload .p-fileupload-content {
  border: 2px dashed var(--border-strong);
  border-radius: 1rem;
  padding: 2.5rem 1rem;
  background: var(--bg-page);
  text-align: center;
  cursor: pointer;
  transition:
    background 0.2s ease,
    border-color 0.2s ease,
    box-shadow 0.2s ease;
}
:host ::ng-deep .cloud-upload .p-fileupload-content:hover {
  background: var(--gray-100);
  border-color: var(--navy-400);
  box-shadow: 0 0 0 1px rgba(96, 165, 250, 0.4);
}
.cloud-drop-area {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.35rem;
}
.cloud-icon {
  font-size: 3rem;
  margin-bottom: 0.25rem;
}
.cloud-title {
  font-weight: 600;
  font-size: 1.05rem;
}
.cloud-subtitle {
  font-size: 0.85rem;
  color: var(--fg-3);
}
.file-list {
  margin-top: 1rem;
  padding-left: 0;
  list-style: none;
  font-size: 0.85rem;
}
/*# sourceMappingURL=company-document-upload.component.css.map */
